<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Change History Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Change History" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read test process'">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col>
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr></b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Name</b-th>
                  <b-td class="w-100">{{ test_process.name }}</b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Description</b-th>
                  <b-td class="w-100">{{ test_process.description }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>

        <div v-for="(item, index) in activity.models" :key="index">
          <div class="d-flex">
            <h3>
              {{ item.updated_at | moment('YYYY-MM-DD HH:mm:ss') }}
            </h3>
          </div>

          <b-card no-body class="bg-light">
            <div>
              <pre class="mb-0">{{ item.properties }}</pre>
            </div>
          </b-card>
        </div>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import { getCollection, getModel } from '@/shared/fetch-utils'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

export default {
  name: "WorkflowTestProcessAuditTrailHistory",
  components: {
    PermissionAlertGate,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      test_process: null,
      test_process_id: this.$route.params.test_process_id || null,
      sample_type_id: this.$route.params.sample_type_id || null,
      activity: null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/audit-trail`,
            title: "Back to Audit Trail",
            variant: "success",
          },
          {
            icon: "fa-eye",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}`,
            title: "View Test Process",
            variant: "info",
          }
        ]
      }
    },

    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async created () {
    this.loading = true

    this.test_process = await getModel({
      model_type: 'test_process',
      id: this.test_process_id,
      message: this.$bvToast,
    })

    this.activity = await getCollection({
      collection_type: 'activity',
      message: this.$bvToast,
      filters: [
        {
          logic: "filterEquals",
          field: "subject_type",
          value: "TestProcess"
        },
        {
          logic: "filterEquals",
          field: "subject_id",
          value: this.test_process_id
        },
      ],
      sort: [
        {
          logic: "sortAddDesc",
          field: "created_at",
        },
      ],
    })

    this.loading = false;
  },
}
</script>
